import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import {
  CommissionType,
  LightLineSheetSet,
} from "@/features/line-sheet-sets/line-sheet-set.types";

export interface UpdateLineSheetSetCommissionRequest {
  commission: number | null;
  commissionType?: CommissionType | null;
}

export interface UpdateLineSheetSetCommissionResponse extends LightLineSheetSet {}

export interface UpdateLineSheetSetCommissionParameter {
  agencyId: number;
  lineSheetSetId: number;
}

export const updateLineSheetSetCommissionTemplateUrl =
  "/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/commission";

export const updateLineSheetSetCommissionKey: YWRKey<UpdateLineSheetSetCommissionParameter> =
  {
    url: (parameter) => {
      return calcUrl(updateLineSheetSetCommissionTemplateUrl, parameter);
    },
    method: "patch",
  };

export default function useUpdateLineSheetSetCommission() {
  const fetcher = useFetcher<
    UpdateLineSheetSetCommissionRequest,
    UpdateLineSheetSetCommissionResponse
  >();
  return useYWR(updateLineSheetSetCommissionKey, fetcher);
}
